import { render, staticRenderFns } from "./DashboardCurrency.vue?vue&type=template&id=c3fa1c9e&scoped=true"
import script from "./DashboardCurrency.vue?vue&type=script&lang=js"
export * from "./DashboardCurrency.vue?vue&type=script&lang=js"
import style0 from "./DashboardCurrency.vue?vue&type=style&index=0&id=c3fa1c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fa1c9e",
  null
  
)

export default component.exports